import { type ComponentProps } from 'react';
import { useMemo } from 'react';

import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { useCurrentNetwork } from 'hb-react/shared/contexts';

const ReactSelectCurrency = ({
  id,
  name,
  ...props
}: ComponentProps<typeof ReactSelectInput>) => {
  const { currentNetwork } = useCurrentNetwork();
  const currencies = currentNetwork?.currencies;

  const options = useMemo(() => {
    const combinedCurrencies = [
      ...(currencies || []),
      ...(Array.isArray(props.value) ? props.value : [props.value]),
    ];
    const uniqueCurrenciesMap = new Map();

    combinedCurrencies.forEach((currency) => {
      if (currency && typeof currency.id !== 'undefined') {
        uniqueCurrenciesMap.set(currency.id, currency);
      }
    });

    return Array.from(uniqueCurrenciesMap.values()).map(({ id, code }) => ({
      value: id,
      label: code,
    }));
  }, [currencies, props.value]);

  return (
    <ReactSelectInput
      placeholder={__('Search and select currency')}
      isMulti
      {...props}
      cacheOptions
      id={id}
      name={name}
      options={options}
    />
  );
};

export default ReactSelectCurrency;
